import { FormHelperText } from '@mui/material';
import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import WsButtonGroup from '../WsButtonGroup/WsButtonGroup';

interface IControlledWsButtonGroup {
  name: string;
  inputTitle: string;
  buttonsList?: Array<string>;
  variant?: 'outlined' | 'text' | 'contained' | 'white';
  showMandatorySymbol?: boolean;
  size?: 'small' | 'medium' | 'large';
  defaultValue?: number;
  defaultMultipleValue?: number[];
  multiple?: boolean;
}

const ControlledWsButtonGroup: FC<IControlledWsButtonGroup> = ({
  name,
  inputTitle,
  buttonsList = [],
  variant,
  showMandatorySymbol,
  size,
  defaultValue,
  defaultMultipleValue,
  multiple,
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <>
          {multiple ? (
            <WsButtonGroup
              inputTitle={inputTitle}
              buttonsList={buttonsList}
              variant={variant}
              selectedMultipleIndexValue={(index: number[], data: string[]) =>
                onChange({ index: index, key: data })
              }
              showMandatorySymbol={showMandatorySymbol}
              size={size}
              multiple={multiple}
              defaultMultipleValue={value?.index ? value.index : defaultMultipleValue}
            />
          ) : (
            <WsButtonGroup
              inputTitle={inputTitle}
              buttonsList={buttonsList}
              variant={variant}
              selectedIndexValue={(index: number, data: string) =>
                onChange({ index: index, key: data })
              }
              showMandatorySymbol={showMandatorySymbol}
              size={size}
              multiple={false}
              defaultValue={value?.index || value?.index == 0 ? value.index : defaultValue}
            />
          )}
          {error && <FormHelperText error>Please select the required field</FormHelperText>}
        </>
      )}
    />
  );
};

export default ControlledWsButtonGroup;
